var _radialGradient, _radialGradient2, _radialGradient3, _linearGradient, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _linearGradient2, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _linearGradient3, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _linearGradient4, _radialGradient23, _radialGradient24, _radialGradient25, _radialGradient26, _radialGradient27, _radialGradient28, _radialGradient29, _radialGradient30, _radialGradient31, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconParrot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 285.169,
    cy: 133.626,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 391.426 429.98)",
    gradientUnits: "userSpaceOnUse",
    r: 237.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0071,
    stopColor: "#da4a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    stopColor: "#d03944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#c62a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c32430"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 270.283,
    cy: 2570.897,
    gradientTransform: "matrix(.931 0 0 .112 11.619 196.033)",
    gradientUnits: "userSpaceOnUse",
    r: 241.318
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e28086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144,
    stopColor: "#e38389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3395,
    stopColor: "#f1bcc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4957,
    stopColor: "#f6d3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5083,
    stopColor: "#f6d5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6494,
    stopColor: "#fbeced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7824,
    stopColor: "#fefafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    stopColor: "#fff"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 39.255,
    cy: 1.872,
    gradientTransform: "matrix(1 0 0 .949 0 .096)",
    gradientUnits: "userSpaceOnUse",
    r: 73.563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0336,
    stopColor: "#fbe2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3951,
    stopColor: "#e4989d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8925,
    stopColor: "#e28086"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a298a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    stopColor: "#a096a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6067,
    stopColor: "#998f9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7408,
    stopColor: "#8c848f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#7b737e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9479,
    stopColor: "#645e67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 129.276,
    cy: 88.819,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 157.438 243.03)",
    gradientUnits: "userSpaceOnUse",
    r: 90.142,
    xlinkHref: "#lg1"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 11.764,
    cy: -56.892,
    gradientTransform: "matrix(.966 -.259 .314 1.171 41.838 104.405)",
    gradientUnits: "userSpaceOnUse",
    r: 62.408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffbe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0842,
    stopColor: "#fefade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#fbf4c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7513,
    stopColor: "#fbf3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8923,
    stopColor: "#faf2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9efaf"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 285.169,
    cy: 133.626,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 391.426 429.98)",
    gradientUnits: "userSpaceOnUse",
    r: 237.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bbef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0065,
    stopColor: "#6bbdf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3886,
    stopColor: "#5da3de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7315,
    stopColor: "#5594d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#528ecb"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 285.169,
    cy: 118.275,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 402.3 403.832)",
    gradientUnits: "userSpaceOnUse",
    r: 267.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9bd069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3725,
    stopColor: "#8bc650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7245,
    stopColor: "#81c041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7dbe3b"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 213.127,
    cy: 428.243,
    gradientTransform: "matrix(1 0 0 .809 0 81.765)",
    gradientUnits: "userSpaceOnUse",
    r: 69.618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#756e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    stopColor: "#726b75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7801,
    stopColor: "#68626b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9654,
    stopColor: "#58535b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 245.379,
    cy: 336.94,
    gradientTransform: "matrix(-.762 -.648 .647 -.76 214.2 752.121)",
    gradientUnits: "userSpaceOnUse",
    r: 77.203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a71f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#ae202b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#bd232f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c32430"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e28086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546,
    stopColor: "#df787e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    stopColor: "#d3545d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#ca3944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8194,
    stopColor: "#c52a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c32430"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 278.377,
    cy: 85.429,
    gradientTransform: "matrix(-.762 -.648 .647 -.76 435.073 330.812)",
    gradientUnits: "userSpaceOnUse",
    r: 190.305,
    xlinkHref: "#lg2"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 32.569,
    cy: 247.066,
    gradientTransform: "matrix(.356 -.935 .598 .228 -126.86 221.193)",
    gradientUnits: "userSpaceOnUse",
    r: 322.908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0166,
    stopColor: "#ffdace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0256,
    stopColor: "#fed7cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#ebaaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    stopColor: "#e4989d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#df858b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6705,
    stopColor: "#cb3f4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8194,
    stopColor: "#c32430"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 277.126,
    cy: 450.268,
    gradientTransform: "matrix(1 0 0 .809 0 85.97)",
    gradientUnits: "userSpaceOnUse",
    r: 84.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f6f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4401,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#817884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#655f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 294.235,
    cy: 461.386,
    gradientUnits: "userSpaceOnUse",
    r: 57.929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    stopColor: "#f9f6f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    stopColor: "#e1dce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1739,
    stopColor: "#bcb5bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#a198a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3461,
    stopColor: "#918794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4052,
    stopColor: "#8b818e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5516,
    stopColor: "#857b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7538,
    stopColor: "#736b76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9877,
    stopColor: "#565159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f57"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 234.626,
    cy: 461.68,
    gradientUnits: "userSpaceOnUse",
    r: 53.269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0161,
    stopColor: "#efecef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0733,
    stopColor: "#e0dce0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#bbb5bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3778,
    stopColor: "#a198a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5046,
    stopColor: "#918794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5983,
    stopColor: "#8b818e"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 236.48,
    cy: 333.485,
    gradientTransform: "matrix(-.762 -.648 .647 -.76 200.76 740.272)",
    gradientUnits: "userSpaceOnUse",
    r: 77.203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e28086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#de5e67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5588,
    stopColor: "#db4350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8063,
    stopColor: "#d93442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82e3d"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 251.833,
    cy: 360.737,
    gradientTransform: "matrix(-.762 -.648 .647 -.76 210.169 798.19)",
    gradientUnits: "userSpaceOnUse",
    r: 66.972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4989d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0953,
    stopColor: "#e2898f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3684,
    stopColor: "#de626c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6194,
    stopColor: "#db4552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#d93443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82e3d"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 357.826,
    cy: 153.236,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 501.382 514.941)",
    gradientUnits: "userSpaceOnUse",
    r: 330.889,
    xlinkHref: "#lg2"
  })), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 348.772,
    cy: 179.64,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 467.244 553.492)",
    gradientUnits: "userSpaceOnUse",
    r: 291.445
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcdf95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0419,
    stopColor: "#b8dd8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#9ecf6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5831,
    stopColor: "#8cc650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#81c041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7dbe3b"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5166,
    stopColor: "#da4a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7251,
    stopColor: "#d84852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8275,
    stopColor: "#d0424c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#c33741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#b12731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a71f29"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 165.81,
    cy: 83.074,
    gradientTransform: "matrix(1 0 0 .949 0 4.275)",
    gradientUnits: "userSpaceOnUse",
    r: 70.763,
    xlinkHref: "#lg3"
  })), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 124.081,
    cy: 26.361,
    gradientTransform: "matrix(.963 -.268 .254 .914 -2.163 35.515)",
    gradientUnits: "userSpaceOnUse",
    r: 72.975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a71f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#da4a54"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 57.805,
    cy: 86.073,
    gradientTransform: "matrix(.82 -.573 .604 .864 -41.555 44.839)",
    gradientUnits: "userSpaceOnUse",
    r: 117.004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eab1b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242,
    stopColor: "#eaafb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7229,
    stopColor: "#e28086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8085,
    stopColor: "#e27d83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8773,
    stopColor: "#e0737a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9401,
    stopColor: "#de626a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#da4a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da4a54"
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 123.202,
    cy: 94.883,
    gradientTransform: "matrix(.82 -.573 .604 .864 -35.075 83.51)",
    gradientUnits: "userSpaceOnUse",
    r: 58.94
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da4a54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6226,
    stopColor: "#e28086"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4206,
    stopColor: "#efeff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6419,
    stopColor: "#e8e7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    stopColor: "#dcd9de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9666,
    stopColor: "#cbc6cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6c1c8"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 140.053,
    cy: 53.911,
    gradientTransform: "matrix(1 0 0 1.212 0 -11.425)",
    gradientUnits: "userSpaceOnUse",
    r: 11.254,
    xlinkHref: "#lg4"
  })), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 118.861,
    cy: 200.552,
    gradientTransform: "matrix(.356 -.935 .598 .228 -43.451 265.92)",
    gradientUnits: "userSpaceOnUse",
    r: 215.918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0166,
    stopColor: "#e4d5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0762,
    stopColor: "#e4cbe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#e4b2c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2886,
    stopColor: "#e4989d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    stopColor: "#de838a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6713,
    stopColor: "#d05059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#c6303b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c32430"
  }))), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 118.861,
    cy: 200.552,
    gradientTransform: "matrix(.356 -.935 .598 .228 -43.451 265.92)",
    gradientUnits: "userSpaceOnUse",
    r: 215.918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0166,
    stopColor: "#e4d5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0886,
    stopColor: "#dfd9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#d2e2c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2886,
    stopColor: "#cbe7af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    stopColor: "#bde09a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6713,
    stopColor: "#9bce67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#85c247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7dbe3b"
  }))), _radialGradient26 || (_radialGradient26 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 357.826,
    cy: 142.418,
    gradientTransform: "matrix(-.705 -.71 .708 -.703 509.045 496.516)",
    gradientUnits: "userSpaceOnUse",
    r: 237.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75cef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1665,
    stopColor: "#6cbded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4869,
    stopColor: "#5ea3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7747,
    stopColor: "#5594cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#528ecb"
  }))), _radialGradient27 || (_radialGradient27 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: 118.861,
    cy: 200.552,
    gradientTransform: "matrix(.356 -.935 .598 .228 -43.451 265.92)",
    gradientUnits: "userSpaceOnUse",
    r: 215.918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2898,
    stopColor: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6155,
    stopColor: "#7eb6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#5e99d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#528ecb"
  }))), _radialGradient28 || (_radialGradient28 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 128.073,
    cy: -13.138,
    gradientTransform: "matrix(.966 -.259 .246 .916 38.542 92.106)",
    gradientUnits: "userSpaceOnUse",
    r: 101.059,
    xlinkHref: "#lg3"
  })), _radialGradient29 || (_radialGradient29 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_29_",
    cx: 135.505,
    cy: -10.149,
    gradientTransform: "matrix(1.187 -.318 .314 1.171 -20.697 110.906)",
    gradientUnits: "userSpaceOnUse",
    r: 57.747,
    xlinkHref: "#lg4"
  })), _radialGradient30 || (_radialGradient30 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_30_",
    cx: 83.719,
    cy: 10.432,
    gradientTransform: "matrix(-.864 -.503 .502 -.863 189.396 132.287)",
    gradientUnits: "userSpaceOnUse",
    r: 59.87,
    xlinkHref: "#lg1"
  })), _radialGradient31 || (_radialGradient31 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_31_",
    cx: 55.727,
    cy: -1.87,
    gradientTransform: "matrix(.966 -.259 .314 1.171 38.82 93.142)",
    gradientUnits: "userSpaceOnUse",
    r: 57.733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9efaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#f9eead"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4841,
    stopColor: "#f8eca5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#f7e797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#f5e084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8316,
    stopColor: "#f2d86b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#efce4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecc32e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m164.552 117.87c-9.656-3.413-20.129-3.772-29.996-1.028-20.106 5.591-34.61 23.104-36.356 43.899-.748 8.906-.664 17.738.197 26.406l44.259-1.337 53.422-55.06c-10.259-4.78-20.778-9.082-31.526-12.88z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.131 512c129.256 0 234.039-12.838 234.039-29.005h-468.079c0 16.167 104.783 29.005 234.04 29.005z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.619 4.285-.212-4.283h-24.033c-6.596-.054-13.308.771-19.989 2.561l-26.126 7c-8.016 2.148-12.773 10.387-10.625 18.403l15.442 57.632 112.786-30.221c-6.614-24.684-24.85-43.151-47.243-51.092z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.69 75.48-25.02 6.704 3.478 6.298c4.665 8.448 13.678 13.298 23.017 12.839l-.004.03h24.115z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.762 111.577-13.429-32.811 6.517-50.799h-25.216l-7.128 7.128c-14.382 14.382-19.999 35.345-14.735 54.991 3.397 12.676 14.884 21.49 28.007 21.49h.768 25.216z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.696 366.691c-.838-35.784-11.195-70.698-30.006-101.15-23.376-37.842-53.493-70.654-88.559-96.989l-55.36 4.696-84.257 75.911c15.135 24.313 37.501 44.163 65.058 56.136l193.657 84.139z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.282 115.018-87.885 72.129c2.212 22.261 9.554 43.44 21.116 62.014l139.617-80.608c-19.578-14.704-50.496-43.122-72.848-53.535z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.489 466.198h-17.341v-47.746l-15.585-11.837-7.047 38.41c-2.25 12.266-12.941 21.173-25.411 21.173h-33.755c-9.277 0-16.797 7.52-16.797 16.797h132.732c0-9.277-7.52-16.797-16.796-16.797z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.035 294.041c-15.562 1.733-28.172 14.24-30.016 29.789-1.029 8.674 1.194 16.801 5.609 23.323 4.885 7.215 8.456 15.233 10.558 23.688l2.156 8.672c5.688 22.878 26.231 38.939 49.805 38.939v-90.442c.001-20.174-17.473-36.267-38.112-33.969z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.63 109.799c0 7.537 4.935 16.385 2.558 23.538-9.616 28.935-6.98 55.574 3.832 84.084 16.53 43.588 39.338 83.581 79.55 107.166l270.087 158.409c-18.98-72.637-54.635-139.847-104.134-196.293l-70.502-80.397-61.774-65.62c-10.433-11.082-19.86-23.07-28.171-35.821l-16.981-19.125z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.32 324.586c-40.212-23.584-71.15-60.21-87.68-103.798-10.812-28.51-11.465-59.875-1.849-88.81 2.377-7.153 3.589-14.641 3.589-22.179l57.564-18.599-4.849-5.461-74.465 24.059c0 7.537-1.212 15.026-3.589 22.179-9.616 28.935-8.963 60.3 1.849 88.81 16.53 43.588 47.468 80.214 87.68 103.798l270.087 158.409c-1.336-5.111-2.754-10.195-4.253-15.251z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.086 466.198h-17.341v-47.746l-15.585-11.837-7.047 38.41c-2.25 12.266-12.941 21.173-25.411 21.173h-33.754c-9.277 0-16.797 7.52-16.797 16.797h132.732c0-9.277-7.52-16.797-16.797-16.797z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.629 445.025 5.883-32.066-8.352-6.343-7.047 38.41c-2.25 12.266-12.941 21.173-25.411 21.173h9.516c12.47-.001 23.161-8.908 25.411-21.174z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.463 466.198h-9.516c-9.277 0-16.797 7.52-16.797 16.796h9.516c.001-9.276 7.521-16.796 16.797-16.796z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.632 294.041c-15.562 1.733-28.172 14.24-30.016 29.789-1.029 8.674 1.194 16.801 5.609 23.323 4.885 7.215 8.456 15.233 10.558 23.688l2.156 8.672c5.688 22.878 26.231 38.939 49.806 38.939v-90.442c0-20.174-17.474-36.267-38.113-33.969z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.252 379.514-2.156-8.672c-2.102-8.455-5.673-16.474-10.558-23.688-4.415-6.521-6.638-14.648-5.609-23.323 1.673-14.106 12.205-25.708 25.764-29.034-3.81-.93-7.87-1.222-12.061-.755-15.562 1.733-28.172 14.24-30.016 29.789-1.029 8.674 1.194 16.801 5.609 23.323 4.885 7.215 8.456 15.233 10.558 23.688l2.156 8.672c5.688 22.878 26.231 38.939 49.805 38.939v-2.657c-16.279-5.46-29.171-18.904-33.492-36.282z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.043 199.375c-36.718-36.157-81.142-64.105-130.371-81.505-9.656-3.413-20.129-3.772-29.996-1.028-20.106 5.591-34.61 23.104-36.356 43.899-.095 1.135-.177 2.269-.245 3.402l96.055 92.46z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.043 199.375c-42.823 23.116-95.622 23.28-139.417-2.005l-57.551-33.227c-1.911 31.641 6.632 62.194 23.207 87.604l51.677 39.197 125.923 29.647 46.476-58.96c-14.45-22.726-31.355-43.586-50.315-62.256z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.63 109.799-1.176-19.633c-1.073-17.906-13.876-32.936-31.384-36.843l105.009 2.055s18.997 49.484 18.997 49.485l-11.352-8.485-4.334 11.915-10.655-7.976-4.32 11.911-10.652-7.977-4.321 11.911-10.654-7.977-4.321 11.911-10.651-7.977-4.314 11.909c-.001 0-15.872-14.228-15.872-14.229z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.135 76.274 55.28-14.812c-1.424-3.709-2.336-6.084-2.336-6.084l-105.009-2.055c17.508 3.907 30.311 18.937 31.384 36.843l.533 8.903c9.083-5.191 16.149-13.246 20.148-22.795z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.563 90.166c-1.073-17.906-13.876-32.936-31.384-36.843l81.9 2.055-105.009-2.055c17.508 3.907 30.311 18.937 31.384 36.843l1.176 19.633c0 .001 15.871 14.229 15.871 14.229l4.314-11.909 4.552 3.409z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.454 90.166.533 8.903c8.731-4.99 15.599-12.626 19.669-21.693-4.633-11.347-14.314-20.192-26.512-23.562l-25.074-.491c17.508 3.907 30.311 18.937 31.384 36.843z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.179 53.323c.662.148 1.317.312 1.966.491l30.65.6v-.272z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.711 160.741c1.746-20.796 16.25-38.309 36.356-43.9 1.051-.292 2.11-.549 3.173-.771-7.772-1.622-15.853-1.373-23.564.771-20.106 5.591-34.61 23.104-36.356 43.899-.095 1.135-.177 2.269-.245 3.402l20.155 11.637c-.099-4.977.057-9.996.481-15.038z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.075 164.143c-1.911 31.641 6.632 62.194 23.207 87.604l15.445 8.917c6.439 3.717 13.01 7.061 19.685 10.034-23.54-25.564-37.466-59.209-38.182-94.918z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.728 260.664-15.445-8.917c15.09 23.133 36.836 42.004 63.409 53.549l193.657 84.139-.533-22.744c-.838-35.784-11.195-70.698-30.006-101.15-.809-1.309-1.626-2.613-2.451-3.91-63.602 35.955-142.993 36.93-208.631-.967z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.282 251.747c15.09 23.133 36.836 42.004 63.41 53.549l193.657 84.139-.21-8.95-173.057-75.189c-18.878-8.202-35.32-20.101-48.67-34.598-6.675-2.973-13.246-6.316-19.685-10.034z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.079 55.378-112.786 30.221-15.443-57.632c-2.148-8.016 2.609-16.255 10.625-18.403l26.126-7.001c39.846-10.676 80.801 12.97 91.478 52.815z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.989 38.465 16.622 62.035 7.859-2.106c20.664-5.537 35.033-24.263 35.033-45.655v-28.57c-9.792-3.42-20.671-4.041-31.424-1.16l-22.674 6.076c-4.086 1.094-6.511 5.294-5.416 9.38z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.886 82.184 25.02-6.704 9.57 16.577c1.791 3.103.444 7.073-2.866 8.444-11.059 2.963-22.713-1.995-28.247-12.018z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.005 105.018c-3.379-12.611 4.105-25.573 16.716-28.953l2.186-.586.366-12.103c.096-3.178-2.454-5.806-5.633-5.806-6.404 0-12.01-4.301-13.667-10.487l-5.123-19.116-7.128 7.128c-14.382 14.382-19.999 35.345-14.735 54.991 3.397 12.676 14.884 21.49 28.007 21.49h.768z",
    fill: "url(#SVGID_31_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParrot);
export default __webpack_public_path__ + "static/media/icon-parrot.df592789985ad32993f8cc1878d352ca.svg";
export { ForwardRef as ReactComponent };